import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import BottomNavigation from './components/BottomNavigation';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import Home from './pages/Home';
import Watch from './pages/Watch';
import Search from './pages/Search';
import Watchlist from './pages/Watchlist';
import CategoryDetail from './pages/CategoryDetail';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactUs from './pages/ContactUs';
import Auth from './pages/Auth';
import './styles/index.css';

import { FaFilm, FaBookOpen, FaTv, FaMusic, FaUser } from 'react-icons/fa';

function App() {
  const categories = [
    {
      name: 'Popular',
      icon: FaFilm,
      path: '/category/popular',
      submenu: [
        { name: 'M A Varughese', path: '/categorydetail/506' },
        { name: 'Rev. Johnson V', path: '/categorydetail/551' },
        { name: 'Bro Suresh Babu', path: '/categorydetail/508' },
        { name: 'Anish Mano Stephen', path: '/categorydetail/571' },
      ]
    },
    {
      name: 'English Preachers',
      icon: FaBookOpen,
      path: '/category/english',
      submenu: [
        { name: 'Reinhard Bonnke', path: '/categorydetail/511' },
        { name: 'Benny Hinn', path: '/categorydetail/518' },
        { name: 'Billy Graham', path: '/categorydetail/540' },
        { name: 'Lee Grady', path: '/categorydetail/548' },
        { name: 'TD Jakes', path: '/categorydetail/556' },
      ]
    },
    {
      name: 'Malayalam Preachers',
      icon: FaTv,
      path: '/category/malayalam',
      submenu: [
        { name: 'Ashari Upadesi', path: '/categorydetail/507' },
        { name: 'PG Vargis', path: '/categorydetail/523' },
        { name: 'Paul Gopalakrishnan', path: '/categorydetail/534' },
        { name: 'Finny Stephen', path: '/categorydetail/537' },
        { name: 'Bethel AG', path: '/categorydetail/533' },
        { name: 'Abraham Varghese', path: '/categorydetail/555' },
        { name: 'Annie George', path: '/categorydetail/557' },
      ]
    },
    {
      name: 'Tamil Preachers',
      icon: FaUser,
      path: '/category/tamil',
      submenu: [
        { name: 'Paul Dhinakaran', path: '/categorydetail/529' },
        { name: 'Mohan C. Lazarus', path: '/categorydetail/530' },
        { name: 'Sam Chelladurai', path: '/categorydetail/535' },
        { name: 'Augustin Jeba Kumar', path: '/categorydetail/543' },
        { name: 'Joel Thomasraj', path: '/categorydetail/563' },
      ]
    },
    {
      name: 'Telugu Preachers',
      icon: FaUser,
      path: '/category/telugu',
      submenu: [
        { name: 'Raj Prakash Paul', path: '/categorydetail/565' },
      ]
    },
    {
      name: 'Songs',
      icon: FaMusic,
      path: '/category/songs',
      submenu: [
        { name: 'English Songs', path: '/categorydetail/514' },
        { name: 'Malayalam Songs', path: '/categorydetail/515' },
        { name: 'Tamil Songs', path: '/categorydetail/516' },
        { name: 'Hindi Songs', path: '/categorydetail/524' },
        { name: 'Kannada Songs', path: '/categorydetail/525' },
        { name: 'Telugu Songs', path: '/categorydetail/526' },
      ]
    }
  ];

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <AnalyticsTracker />
        <div className="flex bg-brand-dark text-white min-h-screen">
          <Sidebar categories={categories} />
          <main className="flex-1 ml-0 md:ml-64 w-full md:w-auto overflow-x-hidden pt-16 md:pt-0 pb-16 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/categorydetail/:id" element={<CategoryDetail />} />
              <Route path="/search" element={<Search />} />
              <Route path="/watchlist" element={<Watchlist />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/auth" element={<Auth />} />
            </Routes>
            <Footer />
          </main>
          <BottomNavigation />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
